import { dimensions, SvgIconProps } from "./SvgIcon";

export const GcalIcon = (props: SvgIconProps) => {
  const { width, height } = dimensions(props, { size: 10 });
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.24675 0H7.62109V2.35562H9.99983V0.664226C10.0005 0.664226 9.88228 0.0642385 9.24675 0Z"
        fill="#1967D2"
      />
      <path
        d="M7.62109 9.98923V9.99502V10.0002L9.99983 7.64453H9.97852L7.62109 9.98923Z"
        fill="#1967D2"
      />
      <path
        d="M10.0003 7.64417V7.62305L9.97917 7.64417H10.0003Z"
        fill="#FBBC05"
      />
      <path
        d="M9.99983 2.35547H7.62109V7.62302H9.99983V2.35547Z"
        fill="#FBBC05"
      />
      <path
        d="M9.97852 7.64453H7.62109V9.98923L9.97852 7.64453Z"
        fill="#EA4335"
      />
      <path
        d="M7.62109 7.64417H9.97852L9.99983 7.62305H7.62109V7.64417Z"
        fill="#EA4335"
      />
      <path
        d="M7.61589 9.99599H7.62165V9.99023L7.61589 9.99599Z"
        fill="#34A853"
      />
      <path
        d="M2.32552 7.62305V9.99473H7.61583L7.62165 7.62305H2.32552Z"
        fill="#34A853"
      />
      <path
        d="M7.62165 7.64424V7.62305L7.61589 9.99473L7.62165 9.98895V7.64424Z"
        fill="#34A853"
      />
      <path
        d="M0 7.62305V9.27205C0.0213137 9.80715 0.600012 9.99473 0.600012 9.99473H2.32513V7.62305H0Z"
        fill="#188038"
      />
      <path
        d="M2.32513 2.35562H7.62126V0H0.667183C0.667183 0 0.0426274 0.0642385 0 0.727822V7.62318H2.32513V2.35562Z"
        fill="#4285F4"
      />
      <path
        d="M4.05759 6.55626C3.93642 6.55626 3.81958 6.54047 3.70707 6.50891C3.59745 6.47735 3.49648 6.43001 3.40416 6.36688C3.31184 6.30089 3.22962 6.21911 3.1575 6.12155C3.08826 6.024 3.03489 5.91066 2.99739 5.78154L3.52965 5.57065C3.56716 5.71411 3.63062 5.82315 3.72005 5.89775C3.80949 5.96948 3.922 6.00535 4.05759 6.00535C4.11817 6.00535 4.17587 5.99674 4.23068 5.97952C4.28549 5.95944 4.33309 5.93218 4.37348 5.89775C4.41387 5.86332 4.4456 5.82315 4.46868 5.77724C4.49465 5.72846 4.50763 5.67394 4.50763 5.61369C4.50763 5.48744 4.46003 5.38844 4.36483 5.31671C4.27251 5.24498 4.14413 5.20911 3.97969 5.20911H3.72438V4.69694H3.95806C4.01576 4.69694 4.07201 4.68977 4.12682 4.67542C4.18164 4.66107 4.22924 4.63955 4.26962 4.61086C4.3129 4.5793 4.34607 4.54056 4.36915 4.49465C4.39512 4.44587 4.4081 4.38992 4.4081 4.3268C4.4081 4.22924 4.37348 4.15033 4.30424 4.09008C4.23501 4.02695 4.14125 3.99539 4.02297 3.99539C3.89603 3.99539 3.79795 4.02982 3.72871 4.09869C3.66236 4.16468 3.6162 4.23928 3.59023 4.32249L3.07096 4.1116C3.09692 4.03986 3.13587 3.9667 3.18779 3.8921C3.23972 3.81462 3.30463 3.74576 3.38252 3.6855C3.4633 3.62238 3.55706 3.57217 3.6638 3.53487C3.77054 3.49469 3.89315 3.47461 4.03162 3.47461C4.17298 3.47461 4.30136 3.49469 4.41675 3.53487C4.53503 3.57504 4.63601 3.63099 4.71967 3.70272C4.80333 3.77158 4.86824 3.85479 4.9144 3.95235C4.96055 4.04704 4.98363 4.15033 4.98363 4.26224C4.98363 4.34832 4.97209 4.42579 4.94902 4.49465C4.92882 4.56352 4.90141 4.62521 4.8668 4.67972C4.83218 4.73424 4.79179 4.78158 4.74563 4.82175C4.70236 4.85906 4.65764 4.88918 4.61148 4.91214V4.94657C4.74996 5.00109 4.86391 5.0886 4.95334 5.20911C5.04566 5.32962 5.09182 5.4817 5.09182 5.66533C5.09182 5.79445 5.0673 5.91353 5.01825 6.02256C4.96921 6.12873 4.89853 6.22198 4.80621 6.30232C4.71678 6.38266 4.6086 6.44435 4.48166 6.48739C4.35473 6.5333 4.21337 6.55626 4.05759 6.55626Z"
        fill="#4285F4"
      />
      <path
        d="M6.1252 6.48739V4.20629L5.6016 4.42579L5.39388 3.94805L6.26368 3.54347H6.69208V6.48739H6.1252Z"
        fill="#4285F4"
      />
    </svg>
  );
};
